(function () {
  'use strict';

  /* ── SEASON / TIME ICONS (inline SVG) ─────────────────────── */
  var ICONS = {
    w: '<svg viewBox="0 0 128 128" fill="currentColor"><path d="M60.3,115.4c0,0-4.7-18.5-5.8-22.9c-0.2-0.6-0.2-0.9-0.2-0.9l5-8.7h9.5l5,8.6c0,0-0.1,0.4-0.3,1c-1.2,4.6-5.8,22.9-5.8,22.9c-0.1,0.5-0.2,1-0.2,1.4c0,2.5,1.6,4.7,3.9,5.4c2.8,0.8,5.7-1,6.5-3.9l3.4-13.1l6.6,12.1c1.5,2.7,4.7,3.6,7.2,2.1c0,0,0.1,0,0.1-0.1c2.6-1.6,3.5-4.9,2-7.6c0,0-0.8-1.5-2-3.4c-2-3.6-4.8-8.7-4.8-8.7s2.2,0.6,4.8,1.3c3.7,1,8.1,2.2,8.1,2.2c3,0.8,6-1,6.8-3.9c0.7-2.8-0.8-5.7-3.4-6.7c-0.2-0.1-0.3-0.1-0.5-0.2c0,0-5.4-1.4-11-2.8C89.2,87.9,83,86.2,83,86.2l-5-8.7l4.8-8.2h10c0,0,1,1,2.4,2.4c4.9,4.6,15,14.2,15,14.2c2.2,2.1,5.7,2.1,7.9,0c2.2-2.1,2.2-5.4,0-7.5l-9.7-9.2h14c3.1,0,5.6-2.4,5.6-5.3c0-2.9-2.5-5.3-5.6-5.3h-13.9l9.6-9.1c2.2-2.1,2.2-5.4,0-7.5c-2.2-2.1-5.7-2.1-7.9,0c0,0-10.2,9.7-15,14.2c-1.4,1.4-2.4,2.4-2.4,2.4H82.7L78,50.5l5-8.7c0,0,6.3-1.7,12.2-3.3c5.6-1.4,11-2.8,11-2.8c0.2,0,0.4-0.1,0.5-0.2c2.6-1,4.1-3.9,3.4-6.7c-0.8-3-3.9-4.7-6.8-3.9c0,0-4.4,1.2-8.1,2.2c-2.6,0.7-4.8,1.3-4.8,1.3s2.8-5.1,4.8-8.7c1.1-1.9,2-3.4,2-3.4c1.5-2.6,0.6-6-2-7.6c0,0-0.1,0-0.1-0.1c-2.5-1.5-5.8-0.6-7.2,2.1l-6.6,12.1L77.9,9.7c-0.8-3-3.7-4.7-6.5-3.9c-2.4,0.7-3.9,2.9-3.9,5.4c0,0.5,0.1,1,0.2,1.4c0,0,4.7,18.3,5.8,22.9c0.2,0.6,0.3,1,0.3,1l-5,8.6l-9.5,0l-5.1-8.7c0,0,0.1-0.3,0.2-0.9c1.1-4.4,5.8-22.9,5.8-22.9c0.7-3-0.9-6-3.7-6.8c-2.8-0.8-5.7,1-6.5,3.9l-3.3,13.1l-6.6-12.1c-1.5-2.7-4.7-3.6-7.2-2c0,0-0.1,0-0.1,0.1c-1.7,1-2.7,2.9-2.7,4.8c0,0.9,0.2,1.9,0.7,2.8c0,0,0.8,1.5,1.9,3.4c2,3.6,4.8,8.8,4.8,8.8s-2.2-0.6-4.8-1.4c-3.7-1-8.1-2.2-8.1-2.2c-3-0.8-6,1-6.8,3.9c-0.1,0.5-0.2,1-0.2,1.4c0,2.3,1.4,4.4,3.6,5.2c0.2,0.1,0.4,0.1,0.5,0.2c0,0,5.4,1.4,11,2.8c6,1.6,12.3,3.3,12.3,3.3l5,8.7l-4.7,8.2H35.2c0,0-0.9-0.9-2.4-2.4C28,51.7,17.8,42,17.8,42c-2.2-2.1-5.7-2.1-7.9,0c-1.1,1-1.6,2.4-1.6,3.8c0,1.4,0.5,2.7,1.6,3.7l9.6,9.1H5.6C2.5,58.7,0,61,0,64c0,2.9,2.5,5.3,5.6,5.3h14l-9.7,9.2c-1.1,1-1.6,2.4-1.6,3.7s0.5,2.7,1.6,3.7c2.2,2.1,5.7,2.1,7.9,0c0,0,10.1-9.6,15-14.2c1.5-1.5,2.4-2.4,2.4-2.4h10.1l4.8,8.2l-5,8.7c0,0-6.3,1.7-12.3,3.3c-5.7,1.4-11,2.8-11,2.8c-0.2,0-0.4,0.1-0.5,0.2c-2.2,0.8-3.6,2.9-3.6,5.2c0,0.5,0.1,1,0.2,1.4c0.8,3,3.8,4.7,6.8,3.9c0,0,4.4-1.2,8.1-2.2c2.6-0.7,4.8-1.4,4.8-1.4s-2.8,5.2-4.8,8.8c-1.1,1.9-1.9,3.4-1.9,3.4c-0.5,0.9-0.7,1.8-0.7,2.8c0,1.9,1,3.7,2.7,4.8c0,0,0.1,0,0.1,0.1c2.5,1.5,5.8,0.6,7.2-2l6.6-12.1l3.3,13.1c0.8,3,3.7,4.7,6.5,3.9C59.4,121.4,61.1,118.4,60.3,115.4z"/></svg>',
    sp: '<svg viewBox="0 0 128 128" fill="currentColor"><path d="M96,0c0,0-10.5,10.2-21.9,14.3c-84.3,30.5-48.8,90-47.6,90.2c0,0,4.7-8.2,11.1-12.9c40.5-29.8,48.8-64.1,48.8-64.1s-9.1,41.3-45.2,67c-8,5.7-13.4,19.6-15.6,33.6c0,0,5.7-2.3,8.1-2.9c0.9-6.2,2.9-12.1,6.3-17.4c50.4,6,66.9-34.6,69.1-48.8C114.1,25.5,96,0,96,0z"/></svg>',
    su: '<svg viewBox="0 0 128 128" fill="currentColor"><path d="M127.6,38.9c-1.8-5.3-4.4-10.3-7.7-14.7c-3.4-4.5-7.4-8.4-12-11.7c-4.7-3.4-10-6.1-15.5-8c-5.5-1.9-11.2-3.1-17-3.6c-5.9-0.5-11.8-0.2-17.6,0.8c-6,1-11.8,2.8-17.4,5.2c-5.4,2.4-10.6,5.4-15.3,9c-4.6,3.5-8.8,7.7-12.3,12.3c-3.6,4.6-6.5,9.7-8.7,15.1c-2.1,5.2-3.5,10.8-4,16.5c-0.5,5.5-0.1,11.1,1.2,16.5c0.5,2,1.1,4,1.8,5.9l0.1,0.2l18.3-0.1l13.6-10.2l17-0.1l9.6-7.2c0,0,18.8,56.2,19.9,59.1c1.3,3.6,4.1,4.3,6.5,3.4c2.1-0.8,3.8-3,2.4-6.9C89,116,70.7,61.5,70.7,61.5l12-0.1l13.6-10.2l17-0.1l14.6-11l-0.1-0.2C127.8,39.6,127.7,39.2,127.6,38.9z"/></svg>',
    a:  '<svg viewBox="0 0 128 128" fill="currentColor"><path d="M17.9,107.1c3.6,3.6,12.2,20.8,12.2,20.8s5.9-12.8,8.4-15.4c2.6-2.6,11.7-1.5,15.4,2.1c0,0-3.3-28,0.4-29.5c3.7-1.5,27.2,36.3,27.2,36.3s0.6-14.1,4-15.9c3.4-1.8,29,9.2,29,9.2s0.3,0.1,0.5,0c0.2-0.2,0-0.5,0-0.5s-11.2-25.5-9.4-28.9c1.8-3.4,15.9-4.1,15.9-4.1S83.6,58,85.1,54.3c1.4-3.7,29.5-0.6,29.5-0.6c-3.7-3.7-4.8-12.9-2.3-15.4c2.6-2.6,15.7-8.5,15.7-8.5s-17.8-8.6-21.3-12.2c-3.6-3.5,1.4-8.2,0.8-8.9c-0.6-0.6-8.4,1-21.1,1.8c-12.7,0.9-22.9,3.1-25.8,0.2c-2.3-2.3-5.7-10.7-5.7-10.7S37.3,24.8,35.9,26.9c-1.4,2.1-3.1,3.7-6.8,0L8.6,4.2L3.5,9.3l23.2,20.1c3.7,3.7,2.1,5.3,0,6.8C24.6,37.6,0,55.3,0,55.3s8.5,3.4,10.7,5.7c2.9,2.9,0.8,13.1,0,25.9C10,99.5,8.4,107.3,9,107.9C9.7,108.6,14.4,103.5,17.9,107.1z M40.6,42.9l-6.7-6.3l2.6-2.6l6.5,6.8l43.8-11.9l-40.8,15l40.2,42.2L44,46.1L30,88.7L40.6,42.9z"/></svg>',
    day:'<svg viewBox="0 0 128 128" fill="currentColor"><path d="M64,26c-21,0-38,17-38,38s17,38,38,38s38-17,38-38S85,26,64,26z M64,92c-15.5,0-28-12.5-28-28c0-15.5,12.5-28,28-28s28,12.5,28,28C92,79.5,79.5,92,64,92z"/><path d="M71.3,14.6L64,0l-7.3,14.6c2.4-0.4,4.8-0.6,7.3-0.6S68.9,14.2,71.3,14.6z"/><path d="M56.7,113.4L64,128l7.3-14.6c-2.4,0.4-4.8,0.6-7.3,0.6S59.1,113.8,56.7,113.4z"/><path d="M0,64l14.6,7.3C14.2,68.9,14,66.5,14,64s0.2-4.9,0.6-7.3L0,64z"/><path d="M128,64l-14.6-7.3c0.4,2.4,0.6,4.8,0.6,7.3s-0.2,4.9-0.6,7.3L128,64z"/></svg>',
    night:'<svg viewBox="0 0 128 128" fill="currentColor"><polygon points="58.3,47.7 65.5,42.5 72.8,47.7 70,39.1 77.3,33.7 68.3,33.7 65.5,25.2 62.8,33.7 53.8,33.7 61.1,39.1"/><path d="M57.3,70.7C38.2,51.6,33.2,23.7,42.3,0C34,3.2,26.1,8.2,19.4,15c-25.9,25.9-25.9,67.8,0,93.6c25.9,25.9,67.8,25.9,93.6,0c6.8-6.7,11.7-14.6,15-22.9C104.3,94.8,76.4,89.8,57.3,70.7z"/></svg>'
  };
  var USE_LABELS = { w:'شتاء', sp:'ربيع', su:'صيف', a:'خريف', day:'نهار', night:'ليل' };
  var USE_LABELS_EN = { w:'Winter', sp:'Spring', su:'Summer', a:'Autumn', day:'Day', night:'Night' };
  /* Season fills are palette-pure navy (--bn) — set in CSS. Seasons are distinguished by their icon, not color. */

  function getLang() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l && l !== 'ar') return 'en';
    var path = window.location.pathname;
    if (/^\/(en|english)(\/|$)/i.test(path)) return 'en';
    return 'ar';
  }

  /* ── NORMALIZE / LOOKUP ─────────────────────────────── */
  var STRIP_ACCENTS = (function() {
    var map = {'à':'a','á':'a','â':'a','ã':'a','ä':'a','å':'a','è':'e','é':'e','ê':'e','ë':'e','ì':'i','í':'i','î':'i','ï':'i','ò':'o','ó':'o','ô':'o','õ':'o','ö':'o','ù':'u','ú':'u','û':'u','ü':'u','ñ':'n','ç':'c','ý':'y','ÿ':'y'};
    return function(s){ return s.replace(/[^ -~]/g, function(c){ return map[c]||c; }); };
  })();
  var STOPWORDS = {by:1,de:1,du:1,di:1,von:1,'for':1,eau:1,parfum:1,elixir:1,aged:1,edp:1,edt:1,edition:1,collection:1,'the':1};
  var HANDLE_STRIPS = ['-aged-cod','-aged','-معتق','-cod','-ade','-agde','-fragrances','-pour-homme','-pour-femme','-for-men','-for-women','-eau-de-parfum','-edp','-edt','-intense','-collection','-limited-edition','-edition'];

  function norm(s) {
    s = STRIP_ACCENTS(s.toLowerCase());
    s = s.replace(/['",.!?()[\]/\-_]/g,' ');
    return s.split(' ').filter(function(w){ return w && !STOPWORDS[w]; }).join(' ');
  }
  function normHandle(h) {
    h = h.toLowerCase();
    var changed = true;
    while (changed) {
      changed = false;
      for (var i=0; i<HANDLE_STRIPS.length; i++) {
        if (h.slice(-HANDLE_STRIPS[i].length) === HANDLE_STRIPS[i]) {
          h = h.slice(0, h.length - HANDLE_STRIPS[i].length);
          changed = true; break;
        }
      }
    }
    return h.replace(/-/g,' ');
  }

  function lookup(searchTerm, handle) {
    if (!window.BKPP_DATA) return null;
    var DB = window.BKPP_DATA;
    var terms = [];
    if (searchTerm) terms.push(norm(searchTerm));
    if (handle)     terms.push(norm(normHandle(handle)));

    // 1. exact match for any term first
    for (var t=0; t<terms.length; t++) {
      var hn = terms[t];
      if (!hn) continue;
      for (var i=0; i<DB.length; i++) {
        if (DB[i].k === hn || DB[i].k2 === hn) return DB[i];
      }
    }

    // 2. prefix match (word boundary, key >= 5 chars) for any term
    for (var t=0; t<terms.length; t++) {
      var hn = terms[t];
      if (!hn) continue;
      for (var i=0; i<DB.length; i++) {
        var n=DB[i].k, fn=DB[i].k2;
        if (n && n.length>=5 && (hn===n || hn.indexOf(n+' ')===0 || n.indexOf(hn+' ')===0)) return DB[i];
        if (fn && fn.length>=5 && (hn===fn || hn.indexOf(fn+' ')===0 || fn.indexOf(hn+' ')===0)) return DB[i];
      }
    }

    // 3. word-set match against name only, words > 4 chars, need >= 2
    for (var t=0; t<terms.length; t++) {
      var hn = terms[t];
      if (!hn) continue;
      var hw = hn.split(' ').filter(function(w){ return w.length>4; });
      if (hw.length >= 2) {
        for (var i=0; i<DB.length; i++) {
          if (DB[i].k.length < 5) continue;
          var nw = DB[i].k.split(' ');
          var nwSet = {};
          for (var j=0; j<nw.length; j++) nwSet[nw[j]]=1;
          var ok = true;
          for (var j=0; j<hw.length; j++) { if (!nwSet[hw[j]]) { ok=false; break; } }
          if (ok) return DB[i];
        }
      }
    }
    return null;
  }

  /* ── RENDER ──────────────────────────────────────────── */
  function $id(id) { return document.getElementById(id); }
  function show(el) { if(el) el.removeAttribute('hidden'); }

  function renderWidget(root, d) {
    var pid = root.id.replace('bkpp-','');
    var en = getLang() === 'en';

    // Section 0 — inspired by
    var insName = $id('bkpp-insname-'+pid);
    if (insName) insName.textContent = d.inspired || '';
    var gender = $id('bkpp-gender-'+pid);
    if (gender && d.gender) gender.textContent = (en && d.gender_en) ? d.gender_en : d.gender;
    var rating = $id('bkpp-rating-'+pid);
    if (rating && d.rating) rating.textContent = '★ ' + d.rating;
    show($id('bkpp-ins-'+pid));

    // Section 1 — accords
    if (d.accords && d.accords.length) {
      var accEl = $id('bkpp-acclist-'+pid);
      if (accEl) {
        accEl.innerHTML = d.accords.map(function(a) {
          var col = accordColor(a.c);
          var light = isLight(col);
          var label = (en && a.n_en) ? a.n_en : a.n;
          return '<div class="bkpp__accord-row">'
            + '<div class="bkpp__accord-bar" data-pct="'+a.p+'" style="background:'+col+';color:'+(light?'#000':'#fff')+'">'
            + '<span class="bkpp__accord-label">'+label+'</span></div></div>';
        }).join('');
      }
      show($id('bkpp-acc-'+pid));
    }

    // Section 2 — pyramid.  Fragrantica publishes some perfumes as a plain note list with no
    // top/heart/base split; those arrive in d.flat and are shown under one neutral heading. Spreading
    // them across the three tiers would be inventing a pyramid the source does not state.
    var hasTiers = (d.top && d.top.length) || (d.mid && d.mid.length) || (d.base && d.base.length);
    var hasFlat  = d.flat && d.flat.length;
    if (hasTiers || hasFlat) {
      var pyrEl = $id('bkpp-pyrlist-'+pid);
      if (pyrEl) {
        var t1 = en ? 'Top Notes' : 'النوتات الأولى';
        var t2 = en ? 'Heart Notes' : 'النوتات الوسطى';
        var t3 = en ? 'Base Notes' : 'النوتات الخلفية';
        pyrEl.innerHTML = tierHtml(t1, d.top, en)
          + tierHtml(t2, d.mid, en)
          + tierHtml(t3, d.base, en)
          + tierHtml(en ? 'Notes' : 'النوتات', d.flat, en);
      }
      show($id('bkpp-pyr-'+pid));
    }

    // Section 3 — when to use
    if (d.seasons) {
      var pairs = ['w','sp','su','a','day','night'];
      var visible = pairs.filter(function(k){ return d.seasons[k] >= 10; });
      if (visible.length) {
        var useEl = $id('bkpp-uselist-'+pid);
        var useLabels = en ? USE_LABELS_EN : USE_LABELS;
        if (useEl) {
          useEl.innerHTML = visible.map(function(k) {
            var pct = d.seasons[k];
            var lit = pct >= 50 ? ' bkpp--lit' : '';
            return '<div class="bkpp__use-item" data-season="'+k+'">'
              + '<div class="bkpp__use-icon'+lit+'" aria-hidden="true">'+ICONS[k]+'</div>'
              + '<div class="bkpp__use-name">'+useLabels[k]+'</div>'
              + '<div class="bkpp__use-track"><div class="bkpp__use-fill" data-pct="'+pct+'"></div></div>'
              + '<div class="bkpp__use-pct">'+pct+'%</div>'
              + '</div>';
          }).join('');
        }
        show($id('bkpp-use-'+pid));
      }
    }

    // Section 4 — longevity & sillage
    if (d.lon || d.sil) {
      if (d.lon) {
        var ld = $id('bkpp-londots-'+pid);
        if (ld) { ld.innerHTML = dotsHtml(d.lon); ld.setAttribute('role','img'); ld.setAttribute('aria-label', (en?'Longevity ':'الثبات ')+d.lon+(en?' of 5':' من ٥')); }
        var ll = $id('bkpp-lonlbl-'+pid);
        if (ll) ll.textContent = (en && d.lon_l_en) ? d.lon_l_en : (d.lon_l || '');
      }
      if (d.sil) {
        var sd = $id('bkpp-sildots-'+pid);
        if (sd) { sd.innerHTML = dotsHtml(d.sil); sd.setAttribute('role','img'); sd.setAttribute('aria-label', (en?'Sillage ':'الانتشار ')+d.sil+(en?' of 5':' من ٥')); }
        var sl = $id('bkpp-sillbl-'+pid);
        if (sl) sl.textContent = (en && d.sil_l_en) ? d.sil_l_en : (d.sil_l || '');
      }
      show($id('bkpp-lon-'+pid));
    }

    // Show root
    root.style.display = '';
  }

  function tierHtml(label, notes, en) {
    if (!notes || !notes.length) return '';
    return '<div class="bkpp__tier">'
      + '<div class="bkpp__tier-divider"><span class="bkpp__tier-label" role="heading" aria-level="4">'+label+'</span></div>'
      + '<div class="bkpp__notes">'
      + notes.map(function(n) {
          var noteId = n.id || (window.BKPP_NOTES_AR && window.BKPP_NOTES_AR[n.n]);
          var displayName = (en && n.n_en) ? n.n_en : n.n;
          var img = noteId
            ? '<img class="bkpp__note-img" src="https://fimgs.net/mdimg/sastojci/t.'+noteId+'.jpg" alt="'+displayName+'" loading="lazy" onerror="this.style.display=\'none\';this.nextSibling.style.display=\'flex\'">'
              + '<div class="bkpp__note-fallback" style="display:none">'+firstLetter(displayName)+'</div>'
            : '<div class="bkpp__note-fallback">'+firstLetter(displayName)+'</div>';
          return '<div class="bkpp__note">'+img+'<span class="bkpp__note-name">'+displayName+'</span></div>';
        }).join('')
      + '</div></div>';
  }

  function dotsHtml(score) {
    var out = '';
    for (var i=1; i<=5; i++) out += '<div class="bkpp__dot'+(i<=score?' bkpp--filled':'')+'"></div>';
    return out;
  }

  function firstLetter(s) {
    for (var i=0; i<s.length; i++) {
      if (s[i] !== ' ') return s[i];
    }
    return '?';
  }

  // Accord swatches come from the store vocabulary. A few records carry no colour (the accord is
  // outside the vocabulary and one was never invented for it) and some older ones carry a malformed
  // 'color=#xxxxxx'. Both used to reach the style attribute verbatim: 'background:undefined'.
  function accordColor(c) {
    c = String(c == null ? '' : c).replace(/^\s*color\s*=\s*/i, '').trim();
    return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(c) ? c : '#9AA0A6';
  }

  function isLight(hex) {
    hex = String(hex == null ? '' : hex).replace('#','');
    if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    if (hex.length < 6) return false;
    var r=parseInt(hex.slice(0,2),16), g=parseInt(hex.slice(2,4),16), b=parseInt(hex.slice(4,6),16);
    return (r*299 + g*587 + b*114) / 1000 > 155;
  }

  /* ── ANIMATIONS (IntersectionObserver) ──────────────── */
  function animateBars(root) {
    var bars = root.querySelectorAll('.bkpp__accord-bar');
    var fills = root.querySelectorAll('.bkpp__use-fill');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          triggerAnims(e.target);
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      triggerAnims(root);
    }

    function triggerAnims(container) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var setFills = function() {
        container.querySelectorAll('.bkpp__use-fill').forEach(function(fill) {
          fill.style.width = (fill.getAttribute('data-pct') || 0) + '%';
        });
      };
      var delay = 0;
      container.querySelectorAll('.bkpp__accord-bar').forEach(function(bar) {
        var pct = parseInt(bar.getAttribute('data-pct'), 10) || 0;
        if (reduce) { bar.style.width = pct + '%'; bar.classList.add('bkpp--animate'); return; }
        setTimeout(function() {
          bar.style.width = pct + '%';
          bar.classList.add('bkpp--animate');
        }, delay);
        delay += 80;
      });
      if (reduce) { setFills(); } else { setTimeout(setFills, 200); }
    }
  }

  /* ── DESCRIPTION NOTES FALLBACK ─────────────────────── */
  function parseDescNotes(s) {
    if (!s) return [];
    var out = [];
    s.split(/[–—\-،,]+/).forEach(function(n) {
      n = n.trim();
      if (!n) return;
      var id = window.BKPP_NOTES_AR && (window.BKPP_NOTES_AR[n] || window.BKPP_NOTES_AR[n.replace(/^ال/, '')]);
      out.push(id ? {n: n, id: id} : {n: n});
    });
    return out;
  }

  function renderDescWidget(root) {
    var top  = parseDescNotes(root.getAttribute('data-top')  || '');
    var mid  = parseDescNotes(root.getAttribute('data-mid')  || '');
    var base = parseDescNotes(root.getAttribute('data-base') || '');
    if (!top.length && !mid.length && !base.length) return;
    var pid = root.id.replace('bkpp-','');
    var pyrEl = $id('bkpp-pyrlist-'+pid);
    var en = getLang() === 'en';
    if (pyrEl) {
      var t1 = en ? 'Top Notes' : 'النوتات الأولى';
      var t2 = en ? 'Heart Notes' : 'النوتات الوسطى';
      var t3 = en ? 'Base Notes' : 'النوتات الخلفية';
      pyrEl.innerHTML = tierHtml(t1, top, en)
        + tierHtml(t2, mid, en)
        + tierHtml(t3, base, en);
    }
    show($id('bkpp-pyr-'+pid));
    root.style.display = '';
  }

  /* ── PER-PRODUCT DATA ────────────────────────────────── */
  // BKPP_DATA is keyed per perfume and matched by name, so several distinct products can land on one
  // record: 'Angel's Share', '…On the Rocks' and '…Paradis' all resolve to 'angels share' and would
  // show one another's pyramid. boroj.notes / boroj.accords are per product and verified against
  // Fragrantica, so where a product carries them they win, and BKPP_DATA supplies the rest
  // (gender, rating, seasons, longevity). Products without the metafield are unaffected.
  function parseAttr(root, name) {
    var raw = root.getAttribute(name);
    if (!raw || raw === 'null') return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function withOwnData(root, d) {
    var notes = parseAttr(root, 'data-notes');
    var accords = parseAttr(root, 'data-accords');
    if (!notes && !accords) return d;
    var out = {};
    if (d) { for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) out[k] = d[k]; }
    if (notes) {
      var any = false;
      ['top','mid','base','flat'].forEach(function(t) {
        var v = notes[t];
        if (v && v.length) { out[t] = v; any = true; } else { delete out[t]; }
      });
      if (!any && d) { ['top','mid','base','flat'].forEach(function(t){ if (d[t]) out[t] = d[t]; }); }
    }
    if (accords && accords.length) out.accords = accords;
    return out;
  }

  /* ── INIT ────────────────────────────────────────────── */
  function initWidget(root) {
    if (root.dataset.bkppDone) return;
    root.dataset.bkppDone = '1';
    var search = root.getAttribute('data-search') || '';
    var handle = root.getAttribute('data-handle') || '';
    var d = lookup(search, handle);
    d = withOwnData(root, d);
    if (d) {
      renderWidget(root, d);
      animateBars(root);
    } else {
      renderDescWidget(root);
    }
  }

  function initAll() {
    document.querySelectorAll('.bkpp').forEach(function(el) { initWidget(el); });
  }

  function waitForDB(fn, retries) {
    if (window.BKPP_DATA) { fn(); return; }
    if (retries <= 0) return;
    setTimeout(function() { waitForDB(fn, retries-1); }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { waitForDB(initAll, 20); });
  } else {
    waitForDB(initAll, 20);
  }

  window.BKPPInit = function(el) { waitForDB(function(){ initWidget(el); }, 10); };

  /* Shared matcher — reused by the fragrance quiz so PDP + quiz resolve identically. */
  window.BKPPLookup = function (searchTerm, handle) { return lookup(searchTerm, handle); };
  window.BKPPNorm = norm;
})();
